import { IconsService } from '$services/icons/icons.service'
import { Component } from '@angular/core'

@Component({
  selector: 'app-post-not-found',
  templateUrl: './post-not-found.component.html',
  styleUrls: ['./post-not-found.component.css']
})
export class PostNotFoundComponent {

  constructor(
    private readonly icons: IconsService
  ) {
    this.icons.registerIcon([`help`])
  }
}
